module.exports = __webpack_public_path__ + "static/media/on-infinite.c4ac61d8.png";